import { createBrowserRouter } from 'react-router-dom'

import {
  BanksParticipation,
  BottlePage,
  BottlesPage,
  ConfettiPage,
  CreateBottle,
  Error,
  HistoryOfTransactions,
  Layout,
  ListOfReferrals,
  MainPage,
  MenuLayoutPage,
  Notifications,
  ParticipantsPage,
  Referrals,
  ReplenishmentPage,
  SendingPage,
  SplashPage,
  TransactionPage,
  Welcome,
  WithdrawalPage,
} from 'src/pages'
import { AttachmentToBottle } from 'src/pages/Bottle/components'
import {
  ChooseTypeOfBottle,
  ConfirmationPage,
  InputAmountOfBottle,
  InputDateOfBottle,
  InputNameOfBottle,
  StatusPage,
} from 'src/pages/CreateBottle/components'
import { ChangeLanguagePage, DeleteDataPage, InfoContainerPage, InputPromoPage } from 'src/pages/MenuLayout/pages'
import { StatusPromoPage } from 'src/pages/MenuLayout/pages/InputPromo/components'
import { SendingStarsPage } from 'src/pages/Sending/components'
import { WelcomeStep } from 'src/pages/Welcome/components'
import { WithdrawalStarsPage, WithdrawalTonPage } from 'src/pages/Withdrawal/components'
import WithdrawalTonWalletPage from 'src/pages/Withdrawal/components/WithdrawalTonWallet/WithdrawalTonWallet'

export const router = createBrowserRouter([
  // welcome page
  {
    path: '/welcome',
    element: <Welcome />,
    children: [
      { path: '/welcome/step-1', element: <WelcomeStep variant='first' /> },
      { path: '/welcome/step-2', element: <WelcomeStep variant='second' /> },
      { path: '/welcome/step-3', element: <WelcomeStep variant='third' /> },
    ],
  },
  {
    path: '/splash',
    element: <SplashPage />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <MainPage />,
      },
      {
        path: '/bottles',
        element: <BottlesPage />,
      },
      {
        path: '/referrals',
        element: <Referrals />,
      },
    ],
  },
  // bottle page
  {
    path: '/referrals-list',
    element: <ListOfReferrals />,
  },
  {
    path: '/bottles/:id',
    element: <BottlePage />,
  },
  {
    path: '/bottles/:id/attachment',
    element: <AttachmentToBottle />,
  },
  {
    path: '/bottles/:id/participants',
    element: <ParticipantsPage />,
  },
  {
    path: '/bottles/join-error',
    element: <Error variant='generalError' type='join_to_bottle_failed' />,
  },
  // create bottle page
  {
    path: '/create-bottle',
    element: <CreateBottle />,
    children: [
      {
        path: '/create-bottle/step-1',
        element: <ChooseTypeOfBottle />,
      },
      {
        path: '/create-bottle/step-2',
        element: <InputNameOfBottle />,
      },
      {
        path: '/create-bottle/step-3',
        element: <InputAmountOfBottle />,
      },
      {
        path: '/create-bottle/step-4',
        element: <InputDateOfBottle />,
      },
      {
        path: '/create-bottle/confirmation',
        element: <ConfirmationPage />,
      },
    ],
  },
  {
    path: '/create-bottle/created',
    element: <StatusPage status='confirmation' />,
  },
  {
    path: '/create-bottle/not-created',
    element: <Error variant='generalError' type='bank_not_created' />,
  },
  {
    path: '/create-bottle/error',
    element: <StatusPage status='error' />,
  },
  // history of transactions page
  {
    path: '/transactions',
    element: <HistoryOfTransactions />,
  },
  {
    path: '/transactions/:id',
    element: <TransactionPage />,
  },
  // notifications page
  {
    path: '/notifications',
    element: <Notifications />,
  },
  // error page
  {
    path: '/banks-participation',
    element: <BanksParticipation />,
  },
  {
    path: '/error',
    element: <Error variant='generalError' type='something_went_wrong' />,
  },
  // sending
  {
    path: '/sending',
    element: <SendingPage />,
  },
  {
    path: '/sending/:username',
    element: <SendingStarsPage />,
  },
  {
    path: '/sending/:username/success',
    element: <ConfettiPage />,
  },
  {
    path: '/sending/:username/error',
    element: <Error variant='generalError' type='failed_send' />,
  },
  // replenishment
  {
    path: '/replenishment',
    element: <ReplenishmentPage />,
  },
  {
    path: '/replenishment/success',
    element: <ConfettiPage />,
  },
  {
    path: '/replenishment/error',
    element: <Error variant='generalError' type='replenishment_failed' />,
  },
  // menu pages
  {
    path: '/menu',
    element: <MenuLayoutPage />,
    children: [
      {
        path: 'language',
        element: <ChangeLanguagePage />,
      },
      {
        path: 'data-deletion',
        element: <DeleteDataPage />,
      },
      { path: 'promo', element: <InputPromoPage /> },
      // { path: 'ton-wallet', element: <InfoContainerPage variant='ton_wallet' status='not_connected' /> },
      { path: 'support', element: <InfoContainerPage variant='support' /> },
      { path: 'logout', element: <InfoContainerPage variant='go_out' /> },
    ],
  },
  // promo page statuses
  {
    path: '/promo-confirm',
    element: <StatusPromoPage status='confirmation' />,
  },
  {
    path: '/promo-error',
    element: <StatusPromoPage status='error' />,
  },
  // withdrawal
  {
    path: '/withdrawal',
    element: <WithdrawalPage />,
  },
  {
    path: '/withdrawal/stars',
    element: <WithdrawalStarsPage />,
  },
  {
    path: '/withdrawal/ton',
    element: <WithdrawalTonPage />,
  },
  {
    path: '/withdrawal/ton/wallet-address',
    element: <WithdrawalTonWalletPage />,
  },
  {
    path: '/withdrawal/error',
    element: <Error variant='generalError' type='output_failed' />,
  },

  // confetti
  {
    path: '/withdrawal/success',
    element: <ConfettiPage />,
  },
])
